import { loadPref, savePref } from './prefStorage';

/** Font size of the Ctr Stats text, in px — adjustable on its own (A− / A+) so it can be
 *  kept readable when the page is zoomed out to fit more counter rows. */
export const STATS_FONT_DEFAULT = 10;
export const STATS_FONT_MIN = 8;
export const STATS_FONT_MAX = 24;
const STORAGE_KEY = 'statsFontPx';

export function clampStatsFont(px: number): number {
  if (!Number.isFinite(px)) return STATS_FONT_DEFAULT;
  return Math.min(STATS_FONT_MAX, Math.max(STATS_FONT_MIN, Math.round(px)));
}

export function loadStatsFont(): number {
  const raw = loadPref(STORAGE_KEY);
  return raw === null ? STATS_FONT_DEFAULT : clampStatsFont(Number(raw));
}

export function saveStatsFont(px: number): void {
  savePref(STORAGE_KEY, String(px));
}
